<template>
     <div class="homes">
         <aboutStyle title="资料下载" ></aboutStyle>
         <div class="collapseCard">
            <el-collapse accordion style="margin-top:20px;margin-bottom:20px;">
                <el-collapse-item v-for="(item) in filePageList" :key="item">
                    <template slot="title">
                        {{item.fileName}}
                        <i class="header-icon el-icon-info"></i>
                    </template>
                    <div class="content">{{item.fileRemark}}</div>
                    <div class="content">
                      <el-button type="success" style="margin-left:10px;margin-right:10px;" @click="downloadClick(item)">下载</el-button>
                    </div>
                </el-collapse-item>
            </el-collapse>
         </div>
        <div class="footers">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" @current-change="currentPageChange" @size-change="handleSizeChange" :page-sizes="[10, 20]" :page-size="queryCondition.pageSize" :total="total" :current-page.sync="currentPage">
            </el-pagination>
      </div>   
    </div>    
</template>
<script>
import aboutStyle from '@/components/aboutStyle.vue';
export default {
  components:{ aboutStyle},
  data(){
      return {
         filePageList:[],
         total:0,
        queryCondition: {
            pageNum: 1,
            pageSize: 10
        },

      }
  },
  created(){
        this.getFilePageList();
  },
  methods:{
    // 页码发生变化
    currentPageChange(val) {
      this.currentPage = val;
      this.queryCondition.pageNum = val;
      this.init();
    },
    // 每页条数发生变化
    handleSizeChange(val) {
      this.queryCondition.pageNum = 1;
      this.queryCondition.pageSize = val;
      this.init();
    },      
      //查询分页下载的列表
    getFilePageList(){
            this.$api.get("/api/web/get_file_list").then((res) => {
              if(res.code != 1){
                  this.$message.error(res.message)
              }else{
                let result = res.response;
                this.total = result.total;
                this.tableData = result.list;
                this.filePageList = result.list
              }
            }).catch((res) => {
              console.error(res)
            })
      },
    downloadClick(item){
        this.$api.get('/api/file_sys/download_file/'+item.filePath).then((res) =>{
            //下载
            if(res.code == 1){
                this.$message.success("已提交下载，请稍等")
                var fileName = res.response.fileName;
                var path = res.response.url;
                this.$api.downLoad(path,fileName);
            }else{
                this.$message.error(res.message)
            }
        }).catch((res) =>{
            console.log("发生错误"+res)
        })
    }  

  }
    
}
</script>
<style lang="less" scoped>
  .homes{
    height: calc(~"100% - 20px");
    margin-top: 20px;
    margin-bottom: 20px;
  .content{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
  }
  .collapseCard{
    height:650px;
  }
  .footers{
    display: flex;
    justify-items: center;
    justify-content: center;
    align-items: center;
  }
    
}
</style>
